module.exports = __webpack_public_path__ + "assets/img/closeX.8b15a460.svg";